module.exports = __webpack_public_path__ + "static/media/main-logo.151e9c80.webp";